import { AddIcon, Button } from '@shared/components';

interface GenerateSeatNumberButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export default function GenerateSeatNumberButton(props: Readonly<GenerateSeatNumberButtonProps>) {
  const { onClick, disabled } = props;

  const handleClick = async () => {
    onClick();
  };

  return (
    <Button
      variant='outlined'
      color='secondary'
      onClick={handleClick}
      disabled={disabled}
      startIcon={<AddIcon />}
    >
      สร้างเลขที่นั่งสอบ
    </Button>
  );
}
